import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.19 56.25h.39c.781 0 1.42.633 1.42 1.406v.938c0 .773-.639 1.406-1.42 1.406H13.464C8.235 60 4 55.805 4 50.625V9.375C4 4.195 8.235 0 13.464 0h40.697A2.82 2.82 0 0157 2.813v43.124c0 1.172-.734 2.18-1.763 2.602-.426 1.887-.52 5.344-.047 7.711z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 45h34V4H19zM8 47a10.468 10.468 0 016-1.87h2V4h-2c-3.313 0-6 2.512-6 5.609V47zM52 56c-.366-2.231-.343-4.944 0-7H13.673c-7.564 0-7.564 7 0 7H52z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.88,
    fill: "#FFF",
    d: "M19 45h34V4H19zM8 47a10.468 10.468 0 016-1.87h2V4h-2c-3.313 0-6 2.512-6 5.609V47zM52 56c-.366-2.231-.343-4.944 0-7H13.673c-7.564 0-7.564 7 0 7H52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.563 19H26.436c-.79 0-1.437-.675-1.437-1.5v-1c0-.825.647-1.5 1.438-1.5h20.125c.79 0 1.437.675 1.437 1.5v1c0 .825-.647 1.5-1.438 1.5zM48 24.5c0 .825-.647 1.5-1.438 1.5H26.439C25.646 26 25 25.325 25 24.5v-1c0-.825.647-1.5 1.438-1.5h20.125c.79 0 1.437.675 1.437 1.5v1z",
    fill: "currentColor"
  })));
};
export default SvgBook;